<template>
  <div>
    <slot :class="{'is-invalid': computedErrors.length > 0}"></slot>
    <div v-for="error in computedErrors" class="invalid-feedback">{{ validationErrorText(error) }}</div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {helper} from "@/service/CommonHelper";

export default defineComponent({
  props: {
    form: {
      type: String,
      default: null
    } as Prop<string|null>,
    field: {
      type: String,
      default: null
    } as Prop<string|null>,
    errors: {
      type: Object as PropType<ValidationErrorDTO[]>,
      default: null
    } as Prop<ValidationErrorDTO[]>
  },
  setup(props) {
    const computedErrors = computed<ValidationErrorDTO[]>(() => {
      if (props.errors === null || props.errors === undefined) {
        return helper.getErrors(props.form!, props.field!);
      }

      return props.errors
    })

    const validationErrorText = (error: ValidationErrorDTO) =>
      error.code === "INVALID_VALUE" && error.message
        ? error.message
        : helper.trans(`server_errors.${error.code}`, null, error.message);

    return {
      computedErrors,
      helper,
      validationErrorText,
    }
  }
})
</script>
